import { Select } from "baseui/select"
import { code, data } from 'currency-codes'
import getSymbolFromCurrency from 'currency-symbol-map'
import {  Value } from "baseui/select";
import { useState } from "react";

const CurrencySelector = ( props: { currencyCode: string | undefined, onCurrencyCodeChanged: any, error?: any}) => {

    const [currency, setCurrency] = useState<Value>([{ id: props.currencyCode, label: props.currencyCode ? code(props.currencyCode)?.currency : '' }]);

    const handleCurrencyChanged = (e: any) => { setCurrency(e.value); props.onCurrencyCodeChanged(e.value[0].id) }
    return (  
    <Select
        options={currencies}
        value={currency}
        searchable={true}
        clearable={false}
        error={props.error}
        onChange={handleCurrencyChanged}
    />)
}

const currencies = data.map((item: any, index: number) => { return { label: `${item.currency} (${getSymbolFromCurrency(item.code)})`, id: item.code } });

export default CurrencySelector;